import dashboardIcon from '@/assets/img/icons/menu/dashboard.svg'
import dashboardBackgroundIcon from '@/assets/img/icons/menu/dashboard-background.svg'
import transactionsIcon from '@/assets/img/icons/menu/transactions.svg'
import transactionsBackgroundIcon from '@/assets/img/icons/menu/transactions-background.svg'
import reimbursementsIcon from '@/assets/img/icons/menu/reimbursements.svg'
import reimbursementsBackgroundIcon from '@/assets/img/icons/menu/reimbursements-background.svg'
import usersIcon from '@/assets/img/icons/menu/users.svg'
import usersBackgroundIcon from '@/assets/img/icons/menu/users-background.svg'
import budgetsIcon from '@/assets/img/icons/menu/budgets.svg'
import budgetsBackgroundIcon from '@/assets/img/icons/menu/budgets-background.svg'

import cardsIcon from '@/assets/img/icons/menu/cards.svg'
import cardsBackgroundIcon from '@/assets/img/icons/menu/cards-background.svg'

import benefitsIcon from '@/assets/img/icons/menu/benefits.svg'
import exportIcon from '@/assets/img/icons/menu/export.svg'
import exportBackgroundIcon from '@/assets/img/icons/menu/export-background.svg'
import settingsIcon from '@/assets/img/icons/menu/settings.svg'
import settingsBackgroundIcon from '@/assets/img/icons/menu/settings-background.svg'
import myTransactionsIcon from '@/assets/img/icons/menu/my-transactions.svg'
import myTransactionsBackgroundIcon from '@/assets/img/icons/menu/my-transactions-background.svg'
import myReimbursementsIcon from '@/assets/img/icons/menu/my-reimbursements.svg'
import myReimbursementsBackgroundIcon from '@/assets/img/icons/menu/my-reimbursements-background.svg'
import myCardsIcon from '@/assets/img/icons/menu/my-cards.svg'
import myCardsBackgroundIcon from '@/assets/img/icons/menu/my-cards-background.svg'

export default {
  computed: {
    menuItems () {
      return [
        {
          name: 'dashboard',
          link: '/dashboard',
          icon: dashboardIcon,
          backgroundIcon: dashboardBackgroundIcon,
          iconClass: 'dashboard',
          roles: [
            'ROLE_REGULAR',
            'ROLE_BOOKKEEPER',
            'ROLE_ADMIN',
            'ROLE_SUPER_ADMIN',
            'ROLE_COMMERCIAL',
            'ROLE_SUPER_BOOKKEEPER'
          ],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: false,
          top_menu: true
        },
        {
          name: 'logs',
          link: '/logs',
          iconClass: 'dashboard',
          icon: dashboardIcon,
          backgroundIcon: dashboardBackgroundIcon,
          roles: ['ROLE_SUPER_ADMIN'],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: false,
          top_menu: true
        },

        {
          name: 'merchants_settings',
          link: '/merchants-settings',
          icon: settingsIcon,
          backgroundIcon: settingsBackgroundIcon,
          iconClass: 'settings',
          roles: ['ROLE_SUPER_ADMIN'],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: false,
          top_menu: true
        },
        {
          name: 'transactions',
          link: '/transactions',
          iconClass: 'transactions',
          icon: transactionsIcon,
          backgroundIcon: transactionsBackgroundIcon,
          roles: [
            'ROLE_REGULAR',
            'ROLE_COMMERCIAL',
            'ROLE_BOOKKEEPER',
            'ROLE_ADMIN',
            'ROLE_SUPER_ADMIN',
            'ROLE_SUPER_BOOKKEEPER'
          ],
          allowedRegularUserRoles: [
            'REVIEWER',
            'OWNER'
          ],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: true,
          top_menu: true
        },
        {
          name: 'reimbursements',
          link: '/reimbursements',
          iconClass: 'reimbursements',
          icon: reimbursementsIcon,
          backgroundIcon: reimbursementsBackgroundIcon,
          roles: [
            'ROLE_COMMERCIAL',
            'ROLE_BOOKKEEPER',
            'ROLE_ADMIN',
            'ROLE_SUPER_ADMIN',
            'ROLE_SUPER_BOOKKEEPER',
            'ROLE_REGULAR'
          ],
          allowedRegularUserRoles: [
            'REVIEWER',
            'OWNER'
          ],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: false,
          top_menu: true
        },
        {
          name: 'customers',
          link: '/customers',
          iconClass: 'users',
          icon: usersIcon,
          backgroundIcon: usersBackgroundIcon,
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_COMMERCIAL'],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: false,
          top_menu: true
        },
        {
          name: 'users',
          link: '/users',
          iconClass: 'users',
          icon: usersIcon,
          backgroundIcon: usersBackgroundIcon,
          roles: ['ROLE_ADMIN', 'ROLE_REGULAR'],
          allowedRegularUserRoles: [
            'OWNER'
          ],

          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: false,
          top_menu: true

        },
        {
          name: 'budgets',
          link: '/budgets',
          iconClass: 'budgets',
          icon: budgetsIcon,
          backgroundIcon: budgetsBackgroundIcon,
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_REGULAR'],
          allowedRegularUserRoles: [
            'OWNER'
          ],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: false,
          top_menu: true
        },
        {
          name: 'cards',
          link: '/all-cards',
          iconClass: 'team_cards',
          icon: cardsIcon,
          backgroundIcon: cardsBackgroundIcon,
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: true,
          needs_office_card: true,
          top_menu: true
        },
        {
          name: 'benefits',
          link: '/benefits',
          iconClass: 'benefits',
          icon: benefitsIcon,
          backgroundIcon: benefitsIcon,
          roles: ['ROLE_ADMIN', 'ROLE_BOOKKEEPER'],
          extraFeatures: true,
          officeFeatureCode: 'FLEXIBLE_REMUNERATION',
          needs_card: false,
          needs_office_card: false,
          top_menu: true

        },
        {
          name: 'export',
          link: '/export',
          iconClass: 'export',
          icon: exportIcon,
          backgroundIcon: exportBackgroundIcon,
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_BOOKKEEPER', 'ROLE_REGULAR'],
          extraFeatures: true,
          officeFeatureCode: 'EXPORT_FUNNEL_FEATURE',
          needs_card: false,
          needs_office_card: false,
          top_menu: true

        },
        {
          name: 'company',
          link: '/company',
          iconClass: 'settings',
          icon: settingsIcon,
          backgroundIcon: settingsBackgroundIcon,
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_BOOKKEEPER'],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: false,
          top_menu: true
        },
        {
          name: 'my_transactions',
          link: '/expenses/transactions/charged',
          iconClass: 'my_transactions',
          icon: myTransactionsIcon,
          backgroundIcon: myTransactionsBackgroundIcon,
          roles: ['ROLE_REGULAR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: true,
          needs_office_card: true,
          top_menu: false
        },
        {
          name: 'my_reimbursements',
          link: '/expenses/reimbursements/history',
          iconClass: 'my_reimbursements',
          icon: myReimbursementsIcon,
          backgroundIcon: myReimbursementsBackgroundIcon,
          roles: ['ROLE_REGULAR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: false,
          top_menu: false
        },
        {
          name: 'my_cards',
          link: '/my-physical-cards',
          iconClass: 'my_cards',
          icon: myCardsIcon,
          backgroundIcon: myCardsBackgroundIcon,
          roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_REGULAR'],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: true,
          needs_office_card: true,
          top_menu: false

        },
        {
          name: 'profile',
          link: '/profile',
          icon: '',
          backgroundIcon: '',
          roles: ['ROLE_REGULAR', 'ROLE_ADMIN', 'ROLE_BOOKKEEPER', 'ROLE_SUPER_ADMIN'],
          extraFeatures: false,
          officeFeatureCode: false,
          needs_card: false,
          needs_office_card: false,
          top_menu: false

        }
      ]
    }

  }
}
